// extracted by mini-css-extract-plugin
export default {"privacyTerms":"PrivacyTerms_privacyTerms__gndg1"};